import { render, staticRenderFns } from "./WidgetsGraphs.vue?vue&type=template&id=67cc5121&scoped=true"
import script from "./WidgetsGraphs.vue?vue&type=script&lang=js"
export * from "./WidgetsGraphs.vue?vue&type=script&lang=js"
import style0 from "./WidgetsGraphs.vue?vue&type=style&index=0&id=67cc5121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_css-loader@6.11.0_webpack@5.106.2__ejs@3.1._9f3d0d3104055eba53a1ff77b8bed3ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc5121",
  null
  
)

export default component.exports